module.exports = __webpack_public_path__ + "static/media/custom-15000-low.1c3646a8.png";